exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-container[data-v-14f48cb5]{position:relative}.code-container .code-btn[data-v-14f48cb5]{cursor:pointer;width:130px;height:42px;position:absolute;top:23px;right:140px;background:#e3efff;border-radius:4px;color:#397efd;font-size:14px;font-weight:300}.code-container .clicked[data-v-14f48cb5],.code-container .locked[data-v-14f48cb5]{color:#fff}", ""]);

// exports
